import axios from "axios";
import { BASE_URL } from "./config";

export const call = (path: string, method: string, request: Request) => {
  return callRaw(path, method, request)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      console.log("API ERROR RESPONSE IS", error);
      if (!error.response) {
        window.dispatchEvent(new CustomEvent("network-error"));
        return { status: 500, data: { message: "Network Error" } };
      }
      if (error.response.status === 440) {
        window.dispatchEvent(new CustomEvent("session-expired"));
      }
      return error.response;
    });
};

export const callRaw = (path: string, method: string, request: Request) => {
  const sessionStr = localStorage.getItem("session");
  let session: any = null;
  try {
    session = sessionStr ? JSON.parse(sessionStr) : null;
  } catch (e) {
    console.warn("Failed to parse session:", sessionStr);
  }

  if (!session || !session.jwtToken) {
    console.warn("Session missing or invalid");
    window.dispatchEvent(new CustomEvent("session-expired"));
    return Promise.resolve({
      status: 440,
      data: { message: "Session Expired" },
    });
  }
  // let session = JSON.parse(localStorage.getItem("session"));;
  const localLang = localStorage.getItem("i18nextLng") || "en";
  let localLangCode = localLang.split("-")[0];
  const supportedLanguages = ["en", "es", "it", "pt", "fr", "de"];
  if (!supportedLanguages.includes(localLangCode)) {
    localLangCode = "en";
  }
  return axios({
    method,
    url: `${BASE_URL}${path}`,
    headers: {
      Accept: "application/json",
      "i18n-Language": localLangCode,
      AccessControlAllowOrigin: "*",
      AccessControlAllowMethods: "PUT,GET,POST,DELETE,OPTIONS",
      Authorization: "Bearer " + session.jwtToken,
      ...request.headers,
    },
    data: request.body,
    params: request.params,
    responseType: request.responseType,
  });
};
